import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getRolesApi,
  createRoleApi,
  deleteRoleApi,
  updateRoleApi,
  assignRoleApi,
} from "./roleApi";

export const getRoles = createAsyncThunk(
  "role/getRoles",
  async (_, thunkAPI) => {
    try {
      const response = await getRolesApi();
      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

export const createRole = createAsyncThunk(
  "role/createRole",
  async (data, thunkAPI) => {
    try {
      const response = await createRoleApi(data);
      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

export const deleteRole = createAsyncThunk(
  "role/deleteRole",
  async (id, thunkAPI) => {
    try {
      await deleteRoleApi(id);
      return id;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

export const updateRole = createAsyncThunk(
  "role/updateRole",
  async ({ id, data }, thunkAPI) => {
    try {
      const response = await updateRoleApi(id, data);
      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

export const assignRole = createAsyncThunk(
  "speaker/assignRole",
  async (data, thunkAPI) => {
    try {
      const response = await assignRoleApi(data);
      return { ...data }; // return userId + roleId
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

const roleSlice = createSlice({
  name: "role",

  initialState: {
    roles: [],
    loading: false,
    error: null,
  },

  reducers: {},

  extraReducers: (builder) => {

    builder
      .addCase(getRoles.pending, (state) => {
        state.loading = true;
      })

      .addCase(getRoles.fulfilled, (state, action) => {
        state.loading = false;
        state.roles = action.payload;
      })

      .addCase(getRoles.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });


    builder
      .addCase(createRole.fulfilled, (state, action) => {
        state.roles.unshift(action.payload);
      });


    builder
      .addCase(deleteRole.fulfilled, (state, action) => {
        state.roles = state.roles.filter(
          (role) => role.id !== action.payload
        );
      });


    builder
      .addCase(updateRole.fulfilled, (state, action) => {
        const index = state.roles.findIndex(
          (role) => role.id === action.payload.id
        );

        if (index !== -1) {
          state.roles[index] = action.payload;
        }
      });

  },
});

export default roleSlice.reducer;